import React, { useEffect, useState } from 'react';
import Swal from "sweetalert2";
import axios from "axios";
import { Link, useHistory } from 'react-router-dom'
import _ from 'lodash';
import Modal from 'react-bootstrap/Modal';


function CategoryList(props) {
    const [CategoryList, setCategoryList] = useState([])
    const [PatientList, setPatientList] = useState([]);

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);

    // const [currentPage, setcurrentPage] = useState(1);
    // const [paginatedPosts, setpaginatedPosts] = useState()

    const navigate = useHistory();
    //  const pageSize = 10;
    // const history=useHistory();


    useEffect(() => {

        LoadCategory();

    }, [])

    const LoadCategory = () => {

        axios.get(`${process.env.REACT_APP_API_URL}/GetAllCategory`)
            .then(res => {
                //console.log("list", res.data)
                setCategoryList(res.data)
                // setpaginatedPosts(_(res.data).slice(0).take(pageSize).value());
            })
    }

    // const handleShow = (item) => {

    //     //console.log("the id get", item)
    //     setShow(true)
    // };

    // const pageCount = IntentList ? Math.ceil(IntentList.length / pageSize) : 0;
    // if (pageCount === 1) return null;
    // const pages = _.range(1, pageCount + 1);

    // const pagination = (pageNo) => {
    //     setcurrentPage(pageNo);
    //     const startIndex = (pageNo - 1) * pageSize;
    //     const paginatedPost = _(IntentList).slice(startIndex).take(pageSize).value();
    //     setpaginatedPosts(paginatedPost)
    // }

    const EditCategory = (valid) => {
        localStorage.setItem('CategoryVal', valid);

        //console.log("the vaue", valid)

    }
    const deleteCategory = (value) => {

        //console.log("the vaue", value)
        setShow(true)
        const datavalue = {
            CatId: value
        }
        var authOptions = {
            method: "post",
            url: `${process.env.REACT_APP_API_URL}/getAllPatientByCategory`,
            data: datavalue,
            headers: { 'Content-Type': 'multipart/form-data' },
        };
        axios(authOptions)
            .then(res => {
                //console.log("all Patient", res.data);
                // //console.log("success")
                setPatientList(res.data)

            })
            .catch(error => {
                //console.log("error occur", error);
            })

    }
    const BackFunc = () => {
        navigate.push('/index')
    }
    return (
        <>
            <div className="page-content-wrapper">
                <div className="page-content">
                    <div className="page-bar">
                        <div className="page-title-breadcrumb">
                            {/* <div className=" pull-left">
                                <div className="page-title">List of Question Categories</div>
                            </div> */}
                            <div className=" pull-right">

                                <button type="submit" className="btn btn-primary d-inline-block" onClick={BackFunc}> <i className="fa fa-arrow-left" aria-hidden="true"></i></button>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                    <div className="col-md-2 col-sm-2">
                        </div>
                        <div className="col-md-8 col-sm-8">
                            <div className="card">
                                <div className="card-head">
                                    <header>Category List</header>
                                    <div className="tools">
                                        {/* <a className="fa fa-repeat btn-color box-refresh" href="javascript:;"></a>
                                                <a className="t-collapse btn-color fa fa-chevron-down"
                                                    href="javascript:;"></a>
                                                <a className="t-close btn-color fa fa-times" href="javascript:;"></a> */}
                                    </div>
                                </div>
                                <div className="card-body ">
                                    <div className="table-responsive">
                                        <table className="table table-striped custom-table table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Category</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    CategoryList && CategoryList.length > 0 && CategoryList.map(item => (
                                                        <tr>
                                                            <td><a href="#">{item.category}</a></td>
                                                            <td>

                                                                <Link to='/UpdateCategory' onClick={() => EditCategory(item.id)}
                                                                    className="btn btn-primary btn-xs py-2"><i className="fa fa-pencil"></i>
                                                                </Link>


                                                                {/* <button className="btn btn-danger btn-xs" onClick={() => deleteCategory(item.id)}> */}
                                                                <button className="btn btn-danger btn-xs py-2" onClick={() => deleteCategory(item.id)}>
                                                                    <i className="fa fa-trash-o "></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    )
                                                    )
                                                }

                                            </tbody>
                                        </table>

                                    </div>
                                    <div>
                                        <Modal show={show} onHide={handleClose}>
                                            <Modal.Header closeButton>
                                                <Modal.Title>Case List</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                                <div className="card-body ">
                                                    <div className="table-responsive">
                                                        <table className="table table-striped custom-table table-hover">
                                                            <thead>
                                                                <tr>
                                                                    <th>Case ID</th>
                                                                    <th>Name</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    PatientList && PatientList.length > 0 && PatientList.map(item => (
                                                                        <tr>
                                                                            <td><a>{item.P_id}</a></td>
                                                                            <td>{item.Patient_Nm}</td>
                                                                        </tr>
                                                                    )
                                                                    )
                                                                }
                                                            </tbody>

                                                        </table>
                                                    </div>
                                                </div>

                                            </Modal.Body>

                                        </Modal>
                                    </div>
                                    {/* <nav className='d-flex justify-content-center'>
                                                <ul className='pagination'>
                                                    {pages.map((page) => (
                                                        <li className={
                                                            page === currentPage ? "page-item active" : "page-item"
                                                        }>
                                                            <p className='page-link' onClick={() => pagination(page)}
                                                            >{page}</p>
                                                        </li>
                                                    ))}

                                                </ul>

                                            </nav> */}
                                </div>

                            </div>
                        </div>
                        <div className="col-md-3 col-sm-3">
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}

export default CategoryList;